import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import './App.css';
import Console from './pages/Console';
import SignalFeed from './pages/SignalFeed';
import PeopleResearch from './pages/PeopleResearch';
import Corpus from './pages/Corpus';
// import MergeReview from './pages/MergeReview'; // hidden for this stage — see App.js nav/routes below
import { ScoringConfigProvider } from './scoring/ScoringConfigContext';
import { AuthProvider, useAuth } from './auth/AuthContext';
import Login from './auth/Login';
import { ChartNoAxesColumn, Activity, UserRoundCheck, Building2, LogOut } from 'lucide-react';


const NAV = [
  { to: '/', label: 'Accounts', end: true, Icon: ChartNoAxesColumn },
  { to: '/signals', label: 'Signal feed', Icon: Activity },
  { to: '/people', label: 'Contact research', Icon: UserRoundCheck },
  { to: '/corpus', label: 'Corpus', Icon: Building2 },
];

function initials(name) {
  return String(name || '?').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('');
}

function Shell() {
  const { user, checking, signOut } = useAuth();
  if (checking) return <div className="state-msg">Loading…</div>;
  if (!user) return <Login />;
  return (
    <ScoringConfigProvider>
      <BrowserRouter>
        <header className="topbar">
          <div className="topbar-inner">
            <div className="topbar-brand">
              <svg width="32" height="32" viewBox="0 0 64 64" aria-hidden="true"><rect width="64" height="64" rx="16" fill="#223252" /><path d="M14 44V22l10 12 8-14 8 14 10-12v22" fill="none" stroke="#16A36A" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" /><circle cx="32" cy="20" r="3.5" fill="#FFFFFF" /></svg>
              MenaGTM
            </div>
            <nav className="topbar-nav" aria-label="Main">
              {NAV.map((item) => (
                <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => `topbar-link${isActive ? ' active' : ''}`}>
                  <item.Icon size={17} strokeWidth={2} aria-hidden="true" />
                  {item.label}
                </NavLink>
              ))}
              {/* Merge review — hidden for this stage, not deleted. Re-enable
                  by adding it to NAV, uncommenting the route below, and the
                  MergeReview import above. */}
            </nav>
            <div className="topbar-scope">
              {/* Only Data labeling / United States have real data; the others are roadmap placeholders. */}
              <select aria-label="Service line" value="data_labeling" onChange={() => {}}>
                <option value="data_labeling">Data labeling</option>
                <option disabled>Talent-as-a-service (soon)</option>
                <option disabled>Custom enterprise AI (soon)</option>
              </select>
              <select aria-label="Region" value="us" onChange={() => {}}>
                <option value="us">United States</option>
                <option disabled>MENA (soon)</option>
              </select>
            </div>
            <div className="who">
              <span className="who-avatar" aria-hidden="true">{initials(user.name)}</span>
              <span className="who-name">{user.name}</span>
              <button type="button" onClick={signOut}><LogOut size={15} aria-hidden="true" />Sign out</button>
            </div>
          </div>
        </header>

        <div className="shell">
          <Routes>
            <Route path="/" element={<Console />} />
            <Route path="/accounts/:accountId" element={<Console />} />
            <Route path="/signals" element={<SignalFeed />} />
            <Route path="/people" element={<PeopleResearch />} />
            <Route path="/corpus" element={<Corpus />} />
            {/* <Route path="/merge-review" element={<MergeReview />} /> */}
          </Routes>

          <div className="foot-note">
            Contact research checks public company pages and public GitHub profiles, then uses
            Hunter Domain Search and Email Verifier to find and check work emails. Only contacts
            with a valid Hunter status are shown for review. It does not access private inboxes or send
            messages. Only Data labeling / United States have real ingested data right now.
          </div>
        </div>
      </BrowserRouter>
    </ScoringConfigProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}

export default App;
